import { render, staticRenderFns } from "./AdSourcePage.vue?vue&type=template&id=0ccd1989"
import script from "./AdSourcePage.vue?vue&type=script&lang=js"
export * from "./AdSourcePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports